// The money breakdown of a CDN / Proforma / Invoice row, in the order it is read:
//
//   Subtotal − Discount + VAT + Shipping = Grand Total
//
// Subtotal is the amount BEFORE discounts. It is worked back from the grand total
// (grand − VAT − shipping = amount after discounts, then add the discounts back)
// instead of trusting the saved `subtotal` column: older invoices saved that
// column before the discount and newer documents after it, so the grand total is
// the only figure that is always right. Used by the lists and their Excel
// exports so both agree.
const n = (v) => parseFloat(v) || 0;
const round2 = (v) => Math.round(v * 100) / 100;

const parseItems = (items) => {
  if (Array.isArray(items)) return items;
  if (typeof items === "string") {
    try {
      const parsed = JSON.parse(items);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  return [];
};

export const docAmounts = (row = {}) => {
  const lineDiscount = parseItems(row.items).reduce((t, l) => t + n(l.discount_amount), 0);
  const discount = n(row.discount_amount) + lineDiscount;
  const vat = n(row.tax_amount);
  const shipping = n(row.shipping_amount);
  const grand = n(row.grand_total);
  const net = Math.max(0, grand - vat - shipping);
  return {
    subtotal: round2(net + discount),
    discount: round2(discount),
    vat: round2(vat),
    shipping: round2(shipping),
    grand: round2(grand),
  };
};
